import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UpdateBookmarkPayload {
  bookmarkId: string;
  title: string;
}

export interface UpdatedBookmarkResponse {
  id: string;
  bookmark_type: string;
  title: string;
  display_title: string;
  created_at: string;
  session: {
    session_id: string;
    header: string;
    created_at: string;
  };
  message: {
    id: string;
    user_message: string;
    timestamp: string;
  };
}

interface UpdateBookmarkState {
  loading: boolean;
  error: string | null;
  updatedBookmark: UpdatedBookmarkResponse | null;
}

const initialState: UpdateBookmarkState = {
  loading: false,
  error: null,
  updatedBookmark: null,
};

const updateBookmarkSlice = createSlice({
  name: 'updateBookmark',
  initialState,
  reducers: {
    updateBookmarkRequest: (
      state,
      _action: PayloadAction<UpdateBookmarkPayload>
    ) => {
      state.loading = true;
      state.error = null;
      state.updatedBookmark = null;
    },

    updateBookmarkSuccess: (
      state,
      action: PayloadAction<UpdatedBookmarkResponse>
    ) => {
      state.loading = false;
      state.updatedBookmark = action.payload;
    },

    updateBookmarkFailure: (
      state,
      action: PayloadAction<string>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },

    clearUpdatedBookmark: (state) => {
      state.updatedBookmark = null;
    },
  },
});

export const {
  updateBookmarkRequest,
  updateBookmarkSuccess,
  updateBookmarkFailure,
  clearUpdatedBookmark,
} = updateBookmarkSlice.actions;

export const updateBookmarkReducer = updateBookmarkSlice.reducer;
export const updateBookmarkActionTypes = updateBookmarkSlice.actions;